/* Pages juridiques (/policies/*), 07-10-2026 : la feuille, le sommaire et
   l'encadré « En bref ». Le HTML des politiques est écrit par Shopify depuis
   l'admin : on le réorganise sans rien en retirer.
   - la feuille : le titre et le texte dans un bloc blanc ;
   - le sommaire : la liste des intertitres (h2), à gauche sur ordinateur,
     repliable en tête sur téléphone ; chaque intertitre reçoit une ancre ;
   - « En bref » : si le texte commence par un paragraphe « En bref », lui et
     la liste qui le suit forment un encadré.
   Sans JavaScript : la page reste lisible, en une colonne. */
(function () {
  var conteneur = document.querySelector('.shopify-policy__container');
  if (!conteneur || conteneur.getAttribute('data-mc-jur')) return;
  conteneur.setAttribute('data-mc-jur', '1');
  var titre = conteneur.querySelector('.shopify-policy__title');
  var corps = conteneur.querySelector('.shopify-policy__body');
  if (!corps) return;
  var rte = corps.querySelector('.rte') || corps;

  var feuille = document.createElement('div');
  feuille.className = 'mc-jur-feuille';
  if (titre) feuille.appendChild(titre);
  feuille.appendChild(corps);
  conteneur.appendChild(feuille);

  // « En bref »
  var premier = rte.firstElementChild;
  while (premier && premier.tagName === 'BR') premier = premier.nextElementSibling;
  if (premier && /^\s*en bref/i.test(premier.textContent)) {
    var bref = document.createElement('div');
    bref.className = 'mc-jur-bref';
    rte.insertBefore(bref, premier);
    bref.appendChild(premier);
    var suivant = bref.nextElementSibling;
    if (suivant && /^(UL|OL)$/.test(suivant.tagName)) bref.appendChild(suivant);
  }

  // Sommaire
  var intertitres = Array.prototype.slice.call(rte.querySelectorAll('h2'));
  if (intertitres.length < 3) return;
  var liste = document.createElement('ol');
  liste.setAttribute('role', 'list');
  intertitres.forEach(function (h, i) {
    if (!h.id) h.id = 'section-' + (i + 1);
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent.replace(/\s+/g, ' ').trim();
    li.appendChild(a);
    liste.appendChild(li);
  });
  var aside = document.createElement('details');
  aside.className = 'mc-jur-sommaire';
  aside.open = window.matchMedia('(min-width: 990px)').matches;
  var resume = document.createElement('summary');
  resume.textContent = 'Sommaire';
  aside.appendChild(resume);
  aside.appendChild(liste);
  conteneur.insertBefore(aside, feuille);
  conteneur.classList.add('mc-jur--sommaire');
})();
